import * as React from 'react';
import { DocumentTitle } from 'view/common/document-title';
import { Message, Description, Container, Link } from './styled';
import { PaperContent } from 'view/layout/paper';

interface Props {
    title: string;
    icon?: React.ComponentClass | React.StatelessComponent;
    header?: string;
    description?: string;
    callToActionHref?: string;
    callToActionText?: string;
    dataTestId?: string;
    actionHrefTarget?: '_blank' | '_self' | '_parent' | '_top';
}

const SimpleIconPage = ({
    actionHrefTarget,
    title,
    header,
    description,
    callToActionHref,
    callToActionText,
    dataTestId,
    icon: Icon,
}: Props) => {
    return (
        <DocumentTitle title={title}>
            <PaperContent>
                <Container data-test-id={dataTestId}>
                    {!!Icon && <Icon />}
                    {!!header && <Message>{header}</Message>}
                    {!!description && <Description>{description}</Description>}
                    {!!callToActionHref && (
                        <Link to={callToActionHref} actionSubjectId="callToAction" target={actionHrefTarget}>
                            {callToActionText}
                        </Link>
                    )}
                </Container>
            </PaperContent>
        </DocumentTitle>
    );
};

export default SimpleIconPage;
